import React from "react";
import { useSelector } from "react-redux";
import Layout from "../../../components/UI/Layout/Layout";
import ExtratoList from "./ExtratoList";
import { LoadingTopBar } from "~/components/UI/LoadingTopBar";

export var ScreensExtrato = function() {
    var extrato = useSelector(function(state) { return state.extrato; });
    var isLoading = extrato && extrato.isLoading;

    return (
        <div>
            <LoadingTopBar isActive={isLoading} />
            <Layout>
                <ExtratoList />
            </Layout>
        </div>
    );
};
